/*
 *
 * LanguageProvider constants
 *
 */

export const CHANGE_LOCALE = 'parousya-saas-web/LanguageToggle/CHANGE_LOCALE';
